import * as v from 'valibot';
import { MIN_APY } from '../../constants';

const MIN_AMOUNT = 0;
const MAX_INIT_DEPOSIT = 999999999;
const MAX_MONTH_DEPOSIT = 1000000;

const MAX_APY = 9.99;

const MIN_AMOUNT_MESSAGE = MIN_AMOUNT.toLocaleString('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const apyMessage = `Please enter a number between ${MIN_APY} and ${MAX_APY}`;
const monthlyDepositMessage = `Please enter an amount between ${MIN_AMOUNT_MESSAGE} and ${MAX_MONTH_DEPOSIT.toLocaleString(
  'en-US',
  {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  },
)}`;
const initialDepositMessage = `Please enter an amount between ${MIN_AMOUNT_MESSAGE} and ${MAX_INIT_DEPOSIT.toLocaleString(
  'en-US',
  {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  },
)}`;
const timePeriodMessage = 'Please enter a number between 1 and 20';

export const hysaCalculatorFormSchema = v.object({
  initialDeposit: v.pipe(
    v.string(initialDepositMessage),
    v.minLength(1, initialDepositMessage),
    v.transform(input => {
      return (input as string).replace(/,/g, '');
    }),
    v.transform(Number),
    v.number(),
    v.minValue(MIN_AMOUNT, initialDepositMessage),
    v.maxValue(MAX_INIT_DEPOSIT, initialDepositMessage),
  ),
  monthlyDeposit: v.pipe(
    v.string(monthlyDepositMessage),
    v.minLength(1, monthlyDepositMessage),
    v.transform(input => {
      return (input as string).replace(/,/g, '');
    }),
    v.transform(Number),
    v.number(),
    v.minValue(MIN_AMOUNT, monthlyDepositMessage),
    v.maxValue(MAX_MONTH_DEPOSIT, monthlyDepositMessage),
  ),
  annualPercentageYield: v.pipe(
    v.string(apyMessage),
    v.minLength(1, apyMessage),
    v.transform(Number),
    v.number(),
    v.minValue(MIN_APY, apyMessage),
    v.maxValue(MAX_APY, apyMessage),
  ),
  timePeriod: v.pipe(
    v.string(apyMessage),
    v.minLength(1, apyMessage),
    v.transform(Number),
    v.number(timePeriodMessage),
    v.minValue(1, timePeriodMessage),
    v.maxValue(20, timePeriodMessage),
  ),
});
